import request from "./request";

export function getPluginConfig(data) {
  return request({
    url: "/api/im/initPlugin",
    method: "post",
    data
  });
}

export function initIM(data) {
  return request({
    url: "/api/im/init",
    method: "post",
    data
  });
}

export function getPluginHelps(data) {
  return request({
    url: "/api/im/pluginAuto",
    method: "post",
    data
  });
}

export function uploadFile(data) {
  return request({
    url: "/api/common/uploadTalk",
    method: "post",
    headers: {
        'Content-Type': 'multipart/form-data'
    },
    data
  });
}

export function getHistoryMessage(data) {
  return request({
    url: `/api/im/historyPage?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
    method: "post",
    data
  });
}

export function init(data) {
  return request({
    url: '/api/aiTalk/initSend',
    method: "post",
    data
  });
}

export function initAgent(data) {
  return request({
    url: '/api/aiTalk/initAgent',
    method: "post",
    data
  });
}

export function saveChat(data) {
  return request({
    url: '/api/aiTalk/saveContext',
    method: "post",
    data
  });
}